<template>
	<div class="d-flex flex-column height-full">
		<div>
			<slot :name="slots[step]" />
		</div>

		<div class="px-6 py-4 d-flex flex-column mt-auto">
			<div class="d-flex gap-1 width-full py-4">
				<div
					v-for="index in slots.length"
					:key="index"
					class="rounded-2 width-full step"
					:class="[index > step + 1 ? 'bg-neutral-200' : 'bg-primary-500']"
				>
					&nbsp;
				</div>
			</div>

			<div class="width-full d-flex justify-space-between">
				<div>
					<PButton v-if="step !== 0" type="text" color="neutral" @click="goToPreviousStep">
						{{ t('admin_dialog_button_go_back') }}
					</PButton>
				</div>

				<PButton type-filled :disabled="disabledContinue" @click="goToNextStep">
					{{ isLastStep && lastStepText ? lastStepText : t('Common_Continue_button_A') }}
				</PButton>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref, computed, useSlots } from 'vue'
	import { useI18n } from 'vue-i18n'

	const slotsObj = useSlots()
	const { t } = useI18n()

	interface Props {
		disabledContinue?: boolean
		lastStepText?: string
	}
	defineProps<Props>()

	interface Emits {
		(e: 'stepChange', value: number): void
		(e: 'submit'): void
	}
	const emit = defineEmits<Emits>()

	const step = ref(0)

	const slots = computed(() => Object.keys(slotsObj))
	const isLastStep = computed(() => step.value + 1 === slots.value.length)

	const goToPreviousStep = () => {
		step.value--
		emit('stepChange', step.value)
	}

	const goToNextStep = () => {
		if (isLastStep.value) return emit('submit')
		step.value++
		emit('stepChange', step.value)
	}

	defineExpose({
		goToNextStep,
		goToPreviousStep,
		step,
	})
</script>

<style scoped lang="scss">
	.step {
		height: 6px;
	}
</style>
